export const avoidMultipleSubmitions = () => {
  const form = document.querySelector("[data-wm-form]");

  if (!form) {
    return;
  }

  const submitButton = form.querySelector('[type="submit"]');

  if (!submitButton) {
    return;
  }

  form.addEventListener("submit", () => {
    if (!wemove.utilities.isAkFormValid(form)) {
      return;
    }

    submitButton.disabled = true;

    window.setTimeout(() => (submitButton.disabled = false), 2000);
  });
};
